module.exports = __webpack_public_path__ + "static/media/seguranca.b494e448.svg";